export default __webpack_public_path__ + "static/media/FrontEndImg.7687e94c.png";